<div class="db-ecommerce-emails__content-header">
  <div>
    <h1>{{ 'text_emailNotifications' | dbText }}</h1>
    <p class="mt4" [innerHTML]="'text_adjustYourEmailNotificationSettings' | dbText"></p>
  </div>
</div>
<div class="db-ecommerce-emails-list-table mt30" >
  <div class="row header-row">
    <div class="cell" [ngClass]="{'manage-email': head === 'Actions'}" *ngFor="let head of heads" [innerHTML]="head"></div>
  </div>
  <div class="row" *ngFor="let email of emailsList">
    <div class="cell">
      <span [innerHTML]="email?.title"></span>
      <i class="db-icon db-icon-info-lined ml5"
      [dsTooltip]="email?.description" [dsTooltipColor]="'black'"
      [hostClass]="'cover-all'"
      dsTooltipPosition="right"
      dsTooltipAlign="center"></i>
    </div>
    <div class="cell" [innerHTML]="'text/' + email?.contentType"></div>
    <div class="cell" [innerHTML]="email?.recipients || ('text_customer' | dbText)"></div>
    <div class="cell manage-email">
      <div>
        <input class="ds-switcher-black ds-control-small"
               type="checkbox" id="{{email?.id}}"
               (change)="updateEmailStatus('email_' + email?.id, $event?.target?.checked)"
               [ngModel]="email?.enabled === 'yes'">
        <label for="{{email?.id}}" class="ds-email-label">
          <span class="ds-switcher-control"></span>
          <div class="tooltip-with-arrow">{{email?.enabled === 'yes' ? ('text_enabled' | dbText) : ('text_disabled' | dbText)}}</div>
        </label>
      </div>
      <p class="manage ml40">
        <a dbWpLink [adminLink]="website?.adminEcommerceUrls['emailName'].replace('sectionId', 'wc_email_' + email?.id)"
           [websiteId]="website?.id" target="_blank" rel="noopener">
          <span>{{ 'text_manage' | dbText}}</span>
        </a>
      </p>
    </div>
  </div>
</div>

